import axios from 'axios'
import store from '@/store'

export default {
  getIssueTypes () {
    return new Promise((resolve, reject) => {
      axios.get('/api/issues/get_issue_types').then(({ data }) => {
        store.dispatch('setIssueTypes', data)
        resolve(true)
      }, error => {
        reject(error)
      })
    })
  },
  getIssueStatuses () {
    return new Promise((resolve, reject) => {
      axios.get('/api/issues/get_issue_statuses').then(({ data }) => {
        store.dispatch('setIssueStatuses', data)
        resolve(true)
      }, error => {
        reject(error)
      })
    })
  },
  getIssueLabels () {
    return new Promise((resolve, reject) => {
      axios.get('/api/issues/get_issue_labels').then(({ data }) => {
        store.dispatch('issue/setLabelsList', data)
        resolve(data)
      }, error => {
        reject(error)
      })
    })
  },
  getIssueNotDoneAndEstimated (params) {
    return new Promise((resolve, reject) => {
      axios.get('/api/issues/not_done_and_estimated', {
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        },
        params
      }).then(({ data }) => {
        resolve(data)
      }, error => {
        reject(error)
      })
    })
  }
}
